export default __webpack_public_path__ + "static/media/ai_governance_high_risk_providers.8bcc16da.svg";